// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { useMutation, useQuery } from "@apollo/client";
import {
  Alert,
  Box,
  Button,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  Checkbox,
  Collapse,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  FormControlLabel,
  Grid,
  Modal,
  Snackbar,
  Stack,
  TextField,
  TextFieldProps,
  Typography,
} from "@mui/material";
import { isBefore } from "date-fns";
import { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { ConfirmDialog } from "@/components/molecules/ConfirmDialog";
import { VoiceMessage } from "@/types/api";

import {
  convertStringToDate,
  secondsToHMS,
  transformDateUTC,
} from "../../../../../../utils/date-utils";
import { ActivitiesFilteringTable } from "../ActivitiesFilteringTable";
import { DateTimePickerComponent } from "../DateTimePicker";
import { dialogContent } from "../dialogContent";
import { CREATE_PLAYLIST } from "./queries";
import { Error, style } from "./styles";
import { CreatePlaylistFormInputs } from "./types";
import { CreatePlaylistInputs, CreatePlaylistProps } from "./types";

const todaysDate = new Date();
const weekFromToday = new Date(Date.now() + 6.048e8);

export const CreatePlaylistModal = (props: CreatePlaylistProps) => {
  const lastWeekMatch = props.lastPlaylist?.title?.match(/[Ww]eek\s*(\d+)/);
  const lastWeekTitle = lastWeekMatch
    ? lastWeekMatch[1]
    : props.lastPlaylist?.title?.replace("week", "").trim();

  // State for the current week number and title
  const [currentWeekNumber, setCurrentWeekNumber] = useState<number>(1);
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [newTitle, setNewTitle] = useState<string>("week 1");

  const [idsForPlaylist, setIdsForPlaylist] = useState<number[]>([]);
  const [first, setfirst] = useState("");
  const [startDateValue, setStartDateValue] = useState<Date | null>(todaysDate);
  const [playlistExistError, setPlaylistExistError] = useState<boolean>(false);
  const [regexError, setregexError] = useState<boolean>(false);
  const [endDateValue, setEndDateValue] = useState<Date | null>(weekFromToday);
  const [areRowsSelected, setAreRowsSelected] = useState<boolean>(false);
  const [confirmOpen, setConfirmOpen] = useState<boolean>(false);
  const [totalLength, setTotalLength] = useState<number>(0);
  const [defaultLength, setDefaultLength] = useState<number>(0);
  const [playlistActivities, setPlaylistActivities] = useState<VoiceMessage[]>([]);
  const [addedActivities, setAddedActivities] = useState<number>(0);
  const [dateOutOfRangeError, setDateOutOfRangeError] = useState<boolean>(false);
  const navigate = useNavigate();
  const [showError, setShowError] = useState<boolean>(false);
  const [createPlaylist, { error }] = useMutation<CreatePlaylistInputs>(CREATE_PLAYLIST);

  const handleCloseDuplicatePlaylist = () => {
    setStartDateValue(todaysDate), setEndDateValue(weekFromToday), setPlaylistActivities([]);
  };

  const latestProgram = props.getLatestProgramObject;

  // Effect to determine the correct week number based on program rounds
  useEffect(() => {
    if (latestProgram && props.latestProgram) {
      let weekNumber = 1;

      if (props.latestProgram.round === latestProgram.round) {
        // Same round - increment week number as before
        weekNumber = lastWeekTitle ? parseInt(lastWeekTitle) + 1 : 1;
      } else if (latestProgram.round > props.latestProgram.round) {
        // New round started - reset to week 1
        weekNumber = 1;
      } else {
        // Fallback - increment as before
        weekNumber = lastWeekTitle ? parseInt(lastWeekTitle) + 1 : 1;
      }

      setCurrentWeekNumber(weekNumber);
      const displayTitle = `week ${weekNumber}`;
      setNewTitle(displayTitle);
      setfirst(displayTitle);
    } else if (!latestProgram && lastWeekTitle) {
      // Fallback when latest program data is not available
      const weekNumber = parseInt(lastWeekTitle) + 1;
      setCurrentWeekNumber(weekNumber);
      const displayTitle = `week ${weekNumber}`;
      setNewTitle(displayTitle);
      setfirst(displayTitle);
    }
  }, [latestProgram, props.latestProgram, lastWeekTitle]);

  useEffect(() => {
    setAddedActivities(0);
  }, []);

  const {
    control,
    handleSubmit,
    setValue,
    formState: { isValid },
    reset,
  } = useForm<CreatePlaylistFormInputs>({
    mode: "onChange",
    defaultValues: {
      title: "",
      startOn: todaysDate,
      endOn: weekFromToday,
      isFreeTrial: false,
      isTracked: true,
    },
  });

  useEffect(() => {
    if (props.duplicatePlaylist) {
      const start = new Date(props.duplicatePlaylist?.startOn ?? todaysDate);
      const end = new Date(props.duplicatePlaylist?.endOn ?? weekFromToday);

      const programStart = latestProgram ? new Date(latestProgram?.start_date) : null;
      const programEnd = latestProgram ? new Date(latestProgram?.end_date) : null;

      // Ensure the dates are within the latest program range
      const adjustedStart = programStart && start < programStart ? programStart : start;
      const adjustedEnd = programEnd && end > programEnd ? programEnd : end;

      setValue("title", (props.duplicatePlaylist?.title ?? "") + " copy");
      setfirst((props.duplicatePlaylist?.title ?? "") + " copy");
      setValue("startOn", adjustedStart);
      setValue("endOn", adjustedEnd);
      setStartDateValue(adjustedStart);
      setEndDateValue(adjustedEnd);
      setValue("isFreeTrial", props.duplicatePlaylist?.isFreeTrial ?? false);
      setValue("isTracked", props.duplicatePlaylist?.isTracked ?? true);
      setPlaylistActivities(
        props.duplicatePlaylist?.playlistVoiceMessages
          ?.map((pvm) => pvm?.voiceMessage)
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line no-extra-boolean-cast
          ?.flatMap((x) => (!!x ? [x] : [])) ?? []
      );
    }
  }, [props.duplicatePlaylist, latestProgram]);

  useEffect(() => {
    if (error) {
      setShowError(true);
    }
  }, [error]);

  useEffect(() => {
    props.getLatestProgramrefetch();
  }, [latestProgram]);

  useEffect(() => {
    // Don't show validation if there's no program data or no end date
    if (!startDateValue || !endDateValue || !latestProgram || !latestProgram.end_date) {
      setDateOutOfRangeError(false);
      return;
    }

    const programStart = new Date(latestProgram?.start_date);
    const programEnd = new Date(latestProgram?.end_date);

    // Normalize dates to compare only the date part (ignore time) in UTC
    const normalizeToDateOnly = (date: Date) => {
      const normalized = new Date(date);
      normalized.setUTCHours(0, 0, 0, 0);
      return normalized;
    };

    const normalizedStartDate = normalizeToDateOnly(startDateValue);
    const normalizedEndDate = normalizeToDateOnly(endDateValue);
    const normalizedProgramStart = normalizeToDateOnly(programStart);
    const normalizedProgramEnd = normalizeToDateOnly(programEnd);

    const isStartBeforeProgram = normalizedStartDate < normalizedProgramStart;
    const isEndAfterProgram = normalizedEndDate > normalizedProgramEnd;

    setDateOutOfRangeError(isStartBeforeProgram || isEndAfterProgram);
  }, [startDateValue, endDateValue, latestProgram]);

  useEffect(() => {
    setIdsForPlaylist(playlistActivities.map((activity) => activity.id));
  }, [playlistActivities]);

  const handleChangeStart = (newValue: Date | null) => {
    setStartDateValue(newValue);
    setValue("startOn", newValue);
  };
  const handleChangeEnd = (newValue: Date | null) => {
    setEndDateValue(newValue);
    setValue("endOn", newValue);
  };

  const checkIfSelectedRows = () => {
    if (areRowsSelected) {
      setConfirmOpen(true);
    }
  };

  useEffect(() => {
    if (props.duplicatePlaylist?.startOn) {
      const duplicateStartDate = new Date(props.duplicatePlaylist?.startOn);
      setStartDateValue(duplicateStartDate);
    }
  }, [props.duplicatePlaylist?.startOn]);

  useEffect(() => {
    if (props.duplicatePlaylist?.endOn) {
      const duplicateEndDate = new Date(props.duplicatePlaylist?.endOn);
      setEndDateValue(duplicateEndDate);
    }
  }, [props.duplicatePlaylist?.endOn]);

  const isDateError =
    !endDateValue || !startDateValue
      ? undefined
      : isBefore(
          convertStringToDate(endDateValue) as Date,
          convertStringToDate(startDateValue) as Date
        );
  const endOnFieldProps: TextFieldProps = {
    error: isDateError,
    helperText: isDateError ? "End date cannot be before start date" : "",
  };

  const [noActivitiesAlertOpen, setNoActivitiesAlertOpen] = useState(false);

  const ButtonLogic = () => {
    const isDisabled = !isValid || isDateError || playlistExistError || dateOutOfRangeError;
    const variant = isDisabled || idsForPlaylist.length === 0 ? "outlined" : "contained";

    return (
      <>
        <Collapse in={noActivitiesAlertOpen} style={{ margin: "10px 0" }}>
          <Alert
            severity="error"
            onClose={() => {
              setNoActivitiesAlertOpen(false);
            }}
          >
            Please choose at least one activity and make sure you add it to playlist
          </Alert>
        </Collapse>
        <Button
          className="button"
          type="submit"
          variant={variant}
          disabled={isDisabled}
          onClick={() => checkIfSelectedRows()}
        >
          Create Playlist
        </Button>
      </>
    );
  };

  const onSubmit: SubmitHandler<CreatePlaylistFormInputs> = async (response) => {
    if (isDateError) {
      return;
    }
    if (idsForPlaylist.length === 0) {
      setNoActivitiesAlertOpen(true);
      return;
    }

    const startDateOnly = startDateValue?.toISOString()?.split("T")[0];
    const startDateTime = startDateOnly?.concat("T00:00:00.000Z");

    const endDateOnly = endDateValue?.toISOString()?.split("T")[0];
    const endDateTime = endDateOnly?.concat("T23:59:59.999Z");

    try {
      const regex = new RegExp(/^week\s*[1-9][0-9]*$/);
      const isValid = regex.test(first);
      if (isValid) {
        await createPlaylist({
          variables: {
            accountId: props.accountId,
            title: first.toLowerCase(),
            voiceMessageIds: idsForPlaylist,
            startOn: startDateTime,
            endOn: endDateTime,
            isFreeTrial: response.isFreeTrial,
            isTracked: response.isTracked,
          },
        });
        props.onClose();

        navigate("/refresh");
      } else {
        setregexError(true);
      }
    } catch (e) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line no-console
      console.error("Failed to create playlist");
      setShowError(true);
    }
  };

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let playlistDurationInSeconds: any = playlistActivities
    ?.map((singleVoiceMessage) => singleVoiceMessage?.audioFile?.durationInSeconds)
    ?.reduce((previousValue?, currentValue?) => (previousValue ?? 0) + (currentValue ?? 0), 0);

  useEffect(() => {
    playlistDurationInSeconds = playlistActivities
      ?.map((singleVoiceMessage) => singleVoiceMessage?.audioFile?.durationInSeconds)
      ?.reduce((previousValue?, currentValue?) => (previousValue ?? 0) + (currentValue ?? 0), 0);

    playlistActivities.length === 0
      ? setTotalLength(playlistDurationInSeconds + addedActivities + defaultLength)
      : setTotalLength(playlistDurationInSeconds + addedActivities);
  }, [addedActivities, playlistActivities, defaultLength]);

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getDatainSeconds = (rows: any) => {
    let selectedActivitiesDuration = 0;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rows.forEach((selectedRows: any) => {
      selectedActivitiesDuration += selectedRows?.voiceMessage?.audioFile?.durationInSeconds;
    });

    setAddedActivities(selectedActivitiesDuration);
  };

  // const isPlaylistPresent = (e: any) => {
  //   // const regex = new RegExp(/^[0-9]+$/);
  //   const regex = new RegExp(/^week\s*[1-9][0-9]*$/);
  //   const isValid = regex.test(e.target.value);
  //   if (props?.playlists?.includes(e.target.value.trim())) {
  //     setPlaylistExistError(true);
  //   } else {
  //     setPlaylistExistError(false);
  //   }
  //   if (!isValid) {
  //     setregexError(true);
  //   } else {
  //     setregexError(false);
  //   }
  // };

  if (!props.open) {
    return null;
  }

  return (
    <>
      <Modal
        open={props.open}
        onClose={() => {
          props.onClose(), reset(), handleCloseDuplicatePlaylist();
          setPlaylistExistError(false);
        }}
      >
        <Box sx={style}>
          <Grid container justifyContent="space-between" sx={{ paddingBottom: "0.5rem" }}>
            <Typography variant="h4">Create Playlist</Typography>

            <Button
              className="button"
              onClick={() => {
                props.onClose();
                handleCloseDuplicatePlaylist();
                reset();
                setAddedActivities(0);
                setPlaylistExistError(false);
              }}
            >
              X
            </Button>
          </Grid>
          <br />
          {/* {dateOutOfRangeError && (
            <div style={{ color: "red" }}>
              Playlist start and end dates must be within the current Intensive
              program date range ({transformDateUTC(latestProgram?.start_date)}{" "}
              - {transformDateUTC(latestProgram?.end_date)}). Please update the
              dates in the patient&apos;s Treatment History table if the program
              period needs to be adjusted.
            </div>
          )} */}
          {dateOutOfRangeError && latestProgram?.end_date && (
            <div style={{ color: "red" }}>
              Playlist start and end dates must be within the current Intensive program date range (
              {transformDateUTC(latestProgram?.start_date)} -{" "}
              {transformDateUTC(latestProgram?.end_date)}). Please update the dates in the
              patient&apos;s Treatment History table if the program period needs to be adjusted.
            </div>
          )}

          <br />

          {/* Only show previous playlist info when not starting at week 1 */}
          {currentWeekNumber !== 1 && lastWeekTitle && (
            <>
              <div style={{ fontWeight: "bold" }}>
                Your previous playlist is Week {lastWeekTitle}
              </div>
              <br />
            </>
          )}
          <Typography component={"span"}>
            <Grid>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container alignItems="flex-start" spacing={1.5}>
                  <Grid item>
                    <Stack>
                      <Controller
                        render={({ field }) => (
                          <TextField
                            {...field}
                            onChange={(e) => {
                              // isPlaylistPresent(e);
                              setfirst(e.target.value.toLowerCase());
                            }}
                            value={first}
                            required={true}
                            label="Playlist Title"
                          />
                        )}
                        name="title"
                        control={control}
                      />
                      {playlistExistError ? (
                        <Error>A playlist already exists with that name</Error>
                      ) : null}
                      {regexError ? (
                        <Error>
                          {" "}
                          Playlist title should be in &apos;week #&apos; format where # is an
                          integer number
                        </Error>
                      ) : null}
                    </Stack>
                  </Grid>
                  <Grid item>
                    <Controller
                      name="startOn"
                      control={control}
                      rules={{ required: true }}
                      // TODO: Fix this the next time the file is edited.
                      // eslint-disable-next-line @typescript-eslint/no-unused-vars
                      render={({ field: { ref, ...rest } }) => (
                        <DateTimePickerComponent
                          dateValue={startDateValue}
                          handleChange={handleChangeStart}
                          label={"Start Date"}
                          required={true}
                          {...rest}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item>
                    <Controller
                      name="endOn"
                      control={control}
                      // TODO: Fix this the next time the file is edited.
                      // eslint-disable-next-line @typescript-eslint/no-unused-vars
                      render={({ field: { ref, ...rest } }) => (
                        <DateTimePickerComponent
                          dateValue={endDateValue}
                          handleChange={handleChangeEnd}
                          label={"End Date"}
                          required={true}
                          textFieldProps={endOnFieldProps}
                          {...rest}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <Stack direction="column">
                      <Typography variant="h6"> Total Length</Typography>
                      <Typography>{secondsToHMS(totalLength)}</Typography>
                    </Stack>
                  </Grid>
                </Grid>

                <br />
                <Typography component={"span"}>
                  <ActivitiesFilteringTable
                    setDefaultLength={setDefaultLength}
                    setAreRowsSelected={setAreRowsSelected}
                    editMode={true}
                    getDatainSeconds={getDatainSeconds}
                    playlistActivities={playlistActivities}
                    setPlaylistActivities={(event) => {
                      setPlaylistActivities(event);
                      setNoActivitiesAlertOpen(false);
                    }}
                    filteredPVMs={props.allPVMs}
                    th={props?.therapist}
                    lastWeekTitle={lastWeekTitle}
                  />
                </Typography>
                <Grid item>
                  {confirmOpen && (
                    <ConfirmDialog
                      confirmOpen={confirmOpen}
                      onSubmit={() => {
                        handleSubmit(onSubmit)();
                        setConfirmOpen(false);
                      }}
                      dialogContent={dialogContent}
                      onClose={() => setConfirmOpen(false)}
                    />
                  )}
                  <ButtonLogic />
                </Grid>
              </form>
            </Grid>
          </Typography>
        </Box>
      </Modal>
      {showError && (
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={showError}
          onClose={() => setShowError(false)}
        >
          <Alert onClose={() => setShowError(false)} severity="error">
            Failed to create playlist. {!idsForPlaylist?.length && "No activities selected."}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};
